import ApiClient from './ApiClient';

class CompanyAssignmentsAPI extends ApiClient {
  constructor() {
    super('company_assignments', { accountScoped: true });
  }
}

export default new CompanyAssignmentsAPI();
